package studio.goodegg.capsule.categories

import com.slack.circuit.runtime.CircuitUiEvent
import studio.goodegg.capsule.PodcastResult

sealed class CategoriesUiEvent : CircuitUiEvent {
    data class OpenCategory(val title: String, val genreId: String) : CategoriesUiEvent()
    data object Back : CategoriesUiEvent()
}
